// Generated by BUCKLESCRIPT VERSION 3.1.5, PLEASE EDIT WITH CARE
'use strict';

var Theme = require("../styles/Theme.js");
var TypedGlamor = require("bs-typed-glamor/src/TypedGlamor.bs.js");

function root(isFlagged, isFocused) {
  return TypedGlamor.css(/* None */0, /* :: */[
              TypedGlamor.label("search-result-item"),
              /* :: */[
                TypedGlamor.display(TypedGlamor.flex),
                /* :: */[
                  TypedGlamor.justifyContent(TypedGlamor.spaceBetween),
                  /* :: */[
                    TypedGlamor.padding2(TypedGlamor.em(1.1), TypedGlamor.em(2)),
                    /* :: */[
                      TypedGlamor.borderTop3(TypedGlamor.px(1), TypedGlamor.solid, Theme.Color[/* subtleBorder */6]),
                      /* :: */[
                        TypedGlamor.cursor(TypedGlamor.pointer),
                        /* :: */[
                          TypedGlamor.select("> *", /* :: */[
                                TypedGlamor.opacity(isFlagged && !isFocused ? 0.5 : 1),
                                /* [] */0
                              ]),
                          /* :: */[
                            TypedGlamor.hover(/* :: */[
                                  TypedGlamor.backgroundColor(TypedGlamor.hsl(TypedGlamor.num(6.9), 0, 90)),
                                  /* :: */[
                                    TypedGlamor.select("> *", /* :: */[
                                          TypedGlamor.opacity(1),
                                          /* [] */0
                                        ]),
                                    /* [] */0
                                  ]
                                ]),
                            /* :: */[
                              TypedGlamor.backgroundColor(isFocused ? TypedGlamor.hsl(TypedGlamor.num(6.9), 90, 90) : Theme.Panel[/* Color */0][/* background */0]),
                              /* :: */[
                                TypedGlamor.select("> *:last-child", /* :: */[
                                      TypedGlamor.textAlign(TypedGlamor.right),
                                      /* [] */0
                                    ]),
                                /* :: */[
                                  TypedGlamor.select("@media (max-width: 600px)", /* :: */[
                                        TypedGlamor.select("& .platforms", /* :: */[
                                              TypedGlamor.display(TypedGlamor.none),
                                              /* [] */0
                                            ]),
                                        /* [] */0
                                      ]),
                                  /* [] */0
                                ]
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var name = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.color(Theme.Color[/* link */5]),
      /* [] */0
    ]);

var version = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.fontSize(TypedGlamor.em(0.85)),
      /* :: */[
        TypedGlamor.fontStyle(TypedGlamor.italic),
        /* :: */[
          TypedGlamor.marginLeft(TypedGlamor.em(0.5)),
          /* :: */[
            TypedGlamor.select("@media (max-width: 600px)", /* :: */[
                  TypedGlamor.display(TypedGlamor.none),
                  /* [] */0
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var description = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.unsafe("textOverflow", "ellipsis"),
      /* :: */[
        TypedGlamor.overflow(TypedGlamor.hidden),
        /* [] */0
      ]
    ]);

var updated = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.opacity(0.5),
      /* :: */[
        TypedGlamor.fontSize(TypedGlamor.em(0.85)),
        /* :: */[
          TypedGlamor.whiteSpace(TypedGlamor.nowrap),
          /* :: */[
            TypedGlamor.select("@media (max-width: 450px)", /* :: */[
                  TypedGlamor.display(TypedGlamor.none),
                  /* [] */0
                ]),
            /* [] */0
          ]
        ]
      ]
    ]);

var stars = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.opacity(0.5),
      /* :: */[
        TypedGlamor.fontSize(TypedGlamor.em(0.85)),
        /* :: */[
          TypedGlamor.whiteSpace(TypedGlamor.nowrap),
          /* [] */0
        ]
      ]
    ]);

var starIcon = TypedGlamor.css(/* None */0, /* :: */[
      TypedGlamor.marginLeft(TypedGlamor.em(0.25)),
      /* :: */[
        TypedGlamor.transforms(/* :: */[
              TypedGlamor.translateY(TypedGlamor.px(-1)),
              /* [] */0
            ]),
        /* :: */[
          TypedGlamor.opacity(0.5),
          /* [] */0
        ]
      ]
    ]);

exports.root = root;
exports.name = name;
exports.version = version;
exports.description = description;
exports.updated = updated;
exports.stars = stars;
exports.starIcon = starIcon;
/* name Not a pure module */



// WEBPACK FOOTER //
// ./src/components/SearchResultItemStyles.js